import { writable } from 'svelte/store';

// Create a store for RTMessages
export const rtMessages = writable([]);


function createSvrEventsStore() {
	const { subscribe, update } = writable([]);

	return {
		subscribe,
		add: (item) => update(items => {
			const nextItems = [item, ...items];
			if (nextItems.length > 100) {
				nextItems.pop(); // remove the last item
			}
			return nextItems;
		})
	};
}

// Create a store for svrEvents
export const svrEvents = createSvrEventsStore([]);


function createSvrMessagesStore() {
	const { subscribe, update } = writable([]);

	return {
		subscribe,
		add: (item) => update(items => {
			const nextItems = [item, ...items];
			if (nextItems.length > 100) {
				nextItems.pop(); // remove the last item
			}
			return nextItems;
		})
	};
}

// Create a store for svrMessages
export const svrMessages = createSvrMessagesStore([]);
